import jQuery from "utilities/vendor/jquery/3.7.1/js/jquery";
import $ from "utilities/vendor/jquery/3.7.1/js/jquery";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.10/js/sparta-ui-layers-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.2.3/js/sparta-global-functions-utility";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.2/js/sparta-input-utility";
import checkbox from "utilities/helpers/helpers-checkbox/4.4.0/js/helpers-checkbox";
import checkboxHelper from "utilities/helpers/helpers-checkbox/4.4.0/js/helpers-checkbox";
import select from "utilities/helpers/helpers-select/3.5.0/js/helpers-select";
import helpersSelect from "utilities/helpers/helpers-select/3.5.0/js/helpers-select";
import selectHelper from "utilities/helpers/helpers-select/3.5.0/js/helpers-select";
import radioButton from "utilities/helpers/helpers-radio-button/4.4.0/js/helpers-radio-button";
import CSRFMiddleware from "utilities/servicing/csrf-middleware-utility/2.1.0/js/csrf-middleware-utility";
import GlobalRequestHeaders from "utilities/servicing/global-request-headers/2.1.0/js/global-request-headers";
import ServicingInterstitial from "utilities/servicing/ool-interstitial-utility/3.0.5/js/ool-interstitial-utility";
import loadingSpinner from "utilities/servicing/loading-spinner-utility/2.1.0/js/loading-spinner-utility";
import Spardux from "utilities/servicing/spardux/3.4.0/js/spardux";
import Module from "utilities/global/sparta-module-utility/6.3.1/js/sparta-module-utility";
import spartaAccordionUtility from "utilities/global/sparta-accordion-utility/7.1.0/js/sparta-accordion-utility";
import spartaMaskingUtility from "utilities/global/sparta-masking-utility/5.6.3/js/sparta-masking-utility";
import textInput from "utilities/helpers/helpers-text-inputs/4.2.0/js/helpers-text-inputs";
import accordion from "utilities/helpers/helpers-accordion/2.4.0/js/helpers-accordion";
import accordionHelper from "utilities/helpers/helpers-accordion/2.4.0/js/helpers-accordion";
import HTTP from "utilities/servicing/http-promise/2.1.0/js/http-promise";
import Pearlux from "utilities/servicing/pearlux/1.0.0/js/pearlux";
import SpaRouter from "utilities/servicing/sparouter/2.3.0/js/router";
import Sparouter from "utilities/servicing/sparouter/2.3.0/js/router";
import formToObject from "utilities/community/form-to-object-utility/1.1.0/js/index";
import HtmlFormToObject from "utilities/community/form-to-object-utility/1.1.0/js/index";

function notice(msgType, message, moduleContext) {
    console.warn(`**ServicingOne [${msgType}]: Module '${moduleContext.constructor.name}' : ${message}`);
  }

function deprecationNotice(message, context) {
    notice('DEPRECATION NOTICE', message, context);
}

function legacyNotice(message, context) {
    notice('LEGACY NOTICE', message, context);
}

export default {
    notice,
    legacyNotice,
    deprecationNotice
}
